import { render, staticRenderFns } from "./BookNavigator.vue?vue&type=template&id=02c609c2&scoped=true&"
import script from "./BookNavigator.vue?vue&type=script&lang=js&"
export * from "./BookNavigator.vue?vue&type=script&lang=js&"
import style0 from "./BookNavigator.vue?vue&type=style&index=0&id=02c609c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c609c2",
  null
  
)

export default component.exports